import { Plugins } from '@leverege/plugin';
export default Plugins.createFactory('ScanTextHandler', {
  strategy: Plugins.ALL,
  pluginKey: 'handler',
  defaultObject: (model, value) => value
});